import { List, LoadingOverlay } from "@mantine/core";
import dayjs                    from "dayjs";

import { useRouteWithParams } from "_common/webview/custom-hooks/useRouterWithParams";
import { SecondaryButton }    from "_components/atoms/button";
import FetchMore              from "_components/atoms/fetchMoreLoader";
import Icon                   from "_components/atoms/icon";
import Render                 from "_components/atoms/render";
import Typography             from "_components/atoms/typography";

import useStyles from "./styles";

function component ( {
	fetchMore,
	history,
	isDepleted,
	isLoading
} ) {
	const { classes } = useStyles ();

	return (
		<div className = { classes.parent }>
			<Typography
				className = { classes.text }
				title     = "Payout History"
				weight    = { 500 }
			/>

			<Render condition = { !history.length }>
				<div className = { classes.emptyView }>

					<Icon
						sameInBothTheme
						className = { classes.watchIcon }
						name      = "emptyWatchState"
					/>

					<Typography
						size   = "lg"
						title  = "No Payout History"
						weight = { 500 }
					/>

					<Typography
						dimmed
						size  = { "sm" }
						title = "When you setup auto payout, its history will appear here."
					/>
				</div>

			</Render>

			<Render condition = { history.length }>
				<List
					classNames = { {
						root        : classes.historyList,
						item        : classes.listItem,
						itemWrapper : classes.listItemWrapper,
						itemLabel   : classes.itemLabel
					} }
				>

					<LoadingOverlay
						overlayBlur    = { 0 }
						overlayOpacity = { 0 }
						visible        = { false }// loading }
					/>

					{
						history.map ( ( transaction, index ) => {
							return (
								<ListItem
									key         = { index }
									transaction = { transaction }
								/>
							);
						} )
					}
				</List>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isDepleted }
					isLoading  = { isLoading }
				/>

			</Render>

		</div>
	);
}

function ListItem ( { transaction } ) {
	const { classes } = useStyles ( { status: transaction.status } );
	const router      = useRouteWithParams ();

	return (
		<List.Item>
			<div
				className = { classes.listItemContent }
				onClick   = { () => {
					router.push ( { pathname: `/diamond-payout/payout-history/${ transaction?.id }` } );
				} }
			>
				<Icon
					className       = { classes.icon }
					name            = "rupee"
					sameInBothTheme = { true }
				/>

				<div className = { classes.left }>
					<Typography title = { `₹${ transaction?.amountafterTax } Auto Payout` }
						weight           = { 500 }
					/>

					<Typography
						color = { "secondary" }
						size  = { "xs" }
						title = { `Pay-out ID: ${ transaction.id }` }
					/>

					<Typography
						color = { "secondary" }
						size  = { "xs" }
						title = { "Account Type: Bank Account" }
					/>

					<SecondaryButton
						className = { classes.readingButton }
						title     = { "View Details" }
						variant   = "outline"
					/>
				</div>

				<div className = { classes.right }>
					<div className = { classes.priceContainer }>
						<div className = { classes.rightTop }>
							<Typography
								title  = { `-${ transaction?.metadata?.diamondQuantity } Diamonds` }
								weight = { 500 }
							/>

						</div>

						<Typography
							color = { "secondary" }
							size  = { "xs" }
							title = { dayjs ( transaction.updated_at ).format ( "DD MMM YYYY, HH:mm" ) }
						/>

						<Typography
							className = { classes.status }
							size      = { "xs" }
							title     = { transaction.status.toLowerCase () }
							tt        = "capitalized"
						/>
					</div>

				</div>
			</div>
		</List.Item>
	);
}
export default component;
